<template>
  <div class="navbar_wrap hidden-xs-only" :style="{ background: navBgColor }">
    <div class="navbar_container">
      <div class="navbar_left" @click="$router.push('/home')">
        <img :src="globalDicts.logo" alt="logo" />
      </div>
      <div class="navbar_center">
        <el-menu :default-active="activeIndex" class="el_menu_demo" mode="horizontal" background-color="rgba(0,0,0,0)"
          :text-color="navBackground" :active-text-color="navBackground" @select="changeCurrentPage">
          <template v-for="item in menuList">
            <el-menu-item v-if="!item.children || item.children.length === 0" 
              :key="item.id" :index="String(item.id)" class="menu_item">
              {{ item.menuName }}
            </el-menu-item>
            <el-submenu v-else :key="item.id" :index="String(item.id)" 
              :popper-append-to-body="false" popper-class="navbar-submenu">
              <template slot="title">{{ item.menuName }}</template>
              <el-menu-item v-for="child in item.children" :key="child.id" :index="String(child.id)"
                class="menu_item">
                {{ child.menuName }}
              </el-menu-item>
            </el-submenu>
          </template>
          <!-- <el-menu-item index="100" class="menu_item"><a href="/demo">立即体验</a></el-menu-item> -->
        </el-menu>
      </div>
      <div class="navbar_right">
        <!-- 语言切换 -->
        <div class="language-switcher">
          <el-dropdown 
            trigger="click" 
            @command="handleLanguageChange"
            :popper-append-to-body="true"
            popper-class="language-dropdown"
          >
            <span class="language-current">
              {{ currentLanguageText }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
              <el-dropdown-item command="en-US">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <span class="right_phone">
          <i class="el-icon-phone"></i>
          <span> {{ globalDicts.contact }} </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      activeIndex: '1',
      navBackground: '#fff',
      navBgColor: '#00bbeeff', // 商务蓝，完全不透明
      isScrolled: false,
      arrowObserver: null,
    }
  },
  computed: {
    ...mapGetters(['getMenuList']),
    menuList() {
      return this.getMenuList
    },
    globalDicts() {
      return this.$store.getters.getDicts;
    },
    currentLanguageText() {
      return this.$i18n.locale === 'zh-CN' ? '中文' : 'English'
    }
  },
  props: {
    selectIndex: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.fetchMenuList().then(() => {
      for (let menu of this.menuList) {
        let ok = false
        if (menu.children) {
          for (let child of menu.children) {
            if (child.routePath === this.$route.path) {
              this.activeIndex = child.id + ''
              ok = true
              break
            }
          }
        }
        if (ok) {
          break
        }
      }
      
      // 在菜单数据加载完成后，使用nextTick确保DOM已更新
      this.$nextTick(() => {
        this.removeArrowIcons()
        // 启动MutationObserver持续监听DOM变化
        this.startArrowIconObserver()
      })
    })
    
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    
    // 立即触发一次滚动处理，确保初始状态正确
    this.handleScroll()
  },
  methods: {
    ...mapActions(['fetchMenuList']),
    changeCurrentPage(index) {
      // 根据menuList查找对应的路由路径
      let routePath = ''
      const findRoute = (menus, targetId) => {
        for (const menu of menus) {
          if (String(menu.id) === targetId) {
            return menu.routePath
          }
          if (menu.children && menu.children.length > 0) {
            const childRoute = findRoute(menu.children, targetId)
            if (childRoute) {
              return childRoute
            }
          }
        }
        return ''
      }
      routePath = findRoute(this.menuList, index)

      if (routePath) {
        this.$router.push(routePath).catch(() => { })
      } else if (index === '100') { // Hardcoded index for "立即体验"
        this.$router.push('/demo').catch(() => { })
      }
    },
    
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      console.log('Scroll position:', scrollTop, 'Navbar color:', this.navBgColor) // 调试信息
      if (scrollTop > 50) {
        this.isScrolled = true
        this.navBgColor = '#00bbeeff' // 滚动时保持商务蓝
      } else {
        this.isScrolled = false
        this.navBgColor = '#00bbeeff' // 顶部时也保持商务蓝
      }
    },
    
    handleLanguageChange(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('preferred-language', lang)
      // 重新获取菜单和字典数据
      this.fetchMenuList().then(() => {
        // 重新获取字典数据
        this.$store.dispatch('fetchDicts')
        // 刷新页面以重新加载所有数据
        window.location.reload()
      })
    },
    
    removeArrowIcons() {
      // 使用JavaScript直接移除所有箭头图标元素
      const navbarCenter = document.querySelector('.navbar_center')
      if (navbarCenter) {
        // 移除所有箭头图标
        const arrowIcons = navbarCenter.querySelectorAll('.el-submenu__icon-arrow, .el-icon-arrow-down, .el-icon-arrow-up')
        arrowIcons.forEach(icon => {
          if (icon.parentNode) {
            icon.parentNode.removeChild(icon)
          }
        })
        
        // 移除所有子菜单标题中的图标元素
        const submenuTitles = navbarCenter.querySelectorAll('.el-submenu__title i')
        submenuTitles.forEach(icon => {
          if (icon.parentNode) {
            icon.parentNode.removeChild(icon)
          }
        })
      }
    },
    
    startArrowIconObserver() {
      // 使用MutationObserver监听DOM变化，持续移除箭头图标
      const navbarCenter = document.querySelector('.navbar_center')
      if (navbarCenter && !this.arrowObserver) {
        this.arrowObserver = new MutationObserver((mutations) => {
          let shouldRemove = false
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
              // 检查新增的节点中是否包含箭头图标
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  if (node.classList && (
                    node.classList.contains('el-submenu__icon-arrow') ||
                    node.classList.contains('el-icon-arrow-down') ||
                    node.classList.contains('el-icon-arrow-up')
                  )) {
                    shouldRemove = true
                  }
                  
                  // 检查子元素中是否包含箭头图标
                  const arrowIcons = node.querySelectorAll && node.querySelectorAll('.el-submenu__icon-arrow, .el-icon-arrow-down, .el-icon-arrow-up')
                  if (arrowIcons && arrowIcons.length > 0) {
                    shouldRemove = true
                  }
                }
              })
            }
          })
          
          if (shouldRemove) {
            this.removeArrowIcons()
          }
        })
        
        // 开始观察
        this.arrowObserver.observe(navbarCenter, {
          childList: true,
          subtree: true
        })
      }
    },
  },
  
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener('scroll', this.handleScroll)
    
    // 清理MutationObserver
    if (this.arrowObserver) {
      this.arrowObserver.disconnect()
      this.arrowObserver = null
    }
  },
}
</script>

<style lang="scss">
.navbar_wrap {
  width: 100%;
  height: 50px;
  backdrop-filter: saturate(180%) blur(0.5rem);
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.navbar_wrap .navbar_container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 0 30px;
  box-sizing: border-box;
}

.navbar_wrap .navbar_container .navbar_left {
  display: flex;
  align-items: center;
  height: 100%;
  flex-shrink: 0;
  margin-right: auto;
}

.navbar_wrap .navbar_container .navbar_left img {
  height: 30px;
  cursor: pointer;
}

.navbar_wrap .navbar_container .navbar_center {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex: 1;
  min-width: 0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.navbar_wrap .navbar_container .navbar_right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  flex-shrink: 0;
  font-size: 14px;
  margin-left: auto;
}

.navbar_wrap .navbar_container .navbar_right a {
  text-decoration: none;
  color: #00bbeeff;
  display: inline-block;
  width: 100px;
  background: #ffa400;
  line-height: 27px;
  text-align: center;
  border-radius: 20px;
  padding: 5px;
}

.navbar_wrap .navbar_container .navbar_center .el_menu_demo {
  border: none;
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.navbar_wrap .navbar_container .navbar_center ::v-deep .el-submenu {
  position: relative !important;
  z-index: 1002 !important;
}

.navbar_wrap .navbar_container .navbar_center ::v-deep .el-submenu__title {
  color: #fff !important;
  height: 50px !important;
  line-height: 50px !important;
  font-size: 13px !important;
}

.navbar_wrap .navbar_container .navbar_center ::v-deep .el-submenu__title:hover {
  background-color: rgba(0, 187, 238, 0.9) !important;
  color: #fff !important;
}

.navbar_wrap .navbar_container .navbar_center ::v-deep .el-submenu.is-opened .el-submenu__title {
  background-color: rgba(0, 187, 238, 0.9) !important;
}

.navbar_wrap .navbar_container .navbar_center ::v-deep .el-menu.el-menu--popup {
  background-color: rgba(0, 187, 238, 0.9) !important;
  border: none;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 1003 !important;
  min-width: 120px;
  margin-top: 0 !important;
  position: fixed !important; /* 改为fixed定位，不随页面滚动 */
  top: 50px !important; /* 固定在导航栏下方 */
  left: auto !important;
  right: auto !important;
  transform: none !important; /* 防止任何transform影响定位 */
  display: block !important;
  opacity: 1 !important;
  visibility: visible !important;
  transition: none !important;
  animation: none !important;
  pointer-events: auto !important;
}

/* 为Element UI子菜单添加自定义类，确保定位正确 */
::v-deep .navbar-submenu {
  position: fixed !important;
  top: 50px !important;
  left: auto !important;
  right: auto !important;
  transform: none !important;
  margin-top: 0 !important;
  z-index: 1003 !important;
}

::v-deep .navbar-submenu .el-menu--popup {
  position: fixed !important;
  top: 50px !important;
  left: auto !important;
  right: auto !important;
  transform: none !important;
  margin-top: 0 !important;
  z-index: 1003 !important;
}

/* 强力移除所有箭头图标 - 确保生效 */
.navbar_wrap .navbar_container .navbar_center ::v-deep .el-submenu__icon-arrow,
.navbar_wrap .navbar_container .navbar_center ::v-deep .el-submenu__title i,
.navbar_wrap .navbar_container .navbar_center ::v-deep .el-submenu__title .el-icon-arrow-down,
.navbar_wrap .navbar_container .navbar_center ::v-deep .el-submenu__title .el-icon-arrow-up,
.navbar_wrap .navbar_container .navbar_center ::v-deep .el-submenu .el-icon-arrow-down,
.navbar_wrap .navbar_container .navbar_center ::v-deep .el-submenu .el-icon-arrow-up {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  width: 0 !important;
  height: 0 !important;
  font-size: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* 调整菜单项间距 - 使其更紧凑 */
.navbar_wrap .navbar_container .navbar_center ::v-deep .el-menu--horizontal > .el-menu-item,
.navbar_wrap .navbar_container .navbar_center ::v-deep .el-menu--horizontal > .el-submenu {
  margin: 0 3px !important;
  padding: 0 8px !important;
}

.navbar_wrap .navbar_container .navbar_center ::v-deep .el-menu--horizontal > .el-menu-item:first-child,
.navbar_wrap .navbar_container .navbar_center ::v-deep .el-menu--horizontal > .el-submenu:first-child {
  margin-left: 0 !important;
}

.navbar_wrap .navbar_container .navbar_center ::v-deep .el-menu--horizontal > .el-menu-item:last-child,
.navbar_wrap .navbar_container .navbar_center ::v-deep .el-menu--horizontal > .el-submenu:last-child {
  margin-right: 0 !important;
}

.navbar_wrap .navbar_container .navbar_center ::v-deep .el-menu--popup .el-menu-item {
  color: #fff !important;
  background-color: rgba(0, 187, 238, 0.9) !important;
  min-width: 120px;
  height: 34px !important;
  line-height: 34px !important;
  font-size: 12px !important;
}

.navbar_wrap .navbar_container .navbar_center ::v-deep .el-menu--popup .el-menu-item:hover {
  background-color: rgba(0, 187, 238, 1) !important;
  color: #fff !important;
}

.navbar_wrap .navbar_container .navbar_center ::v-deep .el-menu--popup .el-menu-item.is-active {
  background-color: rgba(0, 187, 238, 1) !important;
  color: #fff !important;
}

.navbar_wrap .navbar_container .navbar_center ::v-deep .el-submenu .el-menu-item {
  color: #fff !important;
}

.navbar_wrap .navbar_container .navbar_center .menu_item:hover {
  font-weight: 600;
  background: #00000000 !important;
}

.navbar_wrap .navbar_container .navbar_right .right_phone:hover {
  color: #ccc;
}

.navbar_wrap .navbar_container .navbar_right .right_phone {
  transition: all 0.5s;
  display: flex;
  align-items: center;
  margin-left: 2.5rem;
  color: #fff;
}

.navbar_wrap .navbar_container .navbar_right .right_phone i {
  font-size: 16px;
}

.navbar_wrap .navbar_container .navbar_right .right_phone span {
  margin-left: 0.5rem;
}

/* 语言切换器样式 */
.navbar_wrap .navbar_container .navbar_right .language-switcher {
  margin-right: 1.5rem;
}

.navbar_wrap .navbar_container .navbar_right .language-current {
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.navbar_wrap .navbar_container .navbar_right .language-current:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.navbar_wrap .navbar_container .navbar_right ::v-deep .el-dropdown-menu {
  background-color: rgba(0, 187, 238, 0.95) !important;
  border: none;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 2000 !important; /* 确保语言下拉菜单有足够高的层级 */
}

.navbar_wrap .navbar_container .navbar_right ::v-deep .el-dropdown-menu .el-dropdown-menu__item {
  color: #fff !important;
  font-size: 13px;
  padding: 8px 16px;
}

.navbar_wrap .navbar_container .navbar_right ::v-deep .el-dropdown-menu .el-dropdown-menu__item:hover {
  background-color: rgba(0, 187, 238, 1) !important;
  color: #fff !important;
}

/* 语言下拉菜单专用样式 */
::v-deep .language-dropdown {
  z-index: 2000 !important;
}

::v-deep .language-dropdown .el-dropdown-menu {
  z-index: 2000 !important;
}
</style>
